$('#sliderHome').slick({
  autoplay: true,
  autoplaySpeed: 5000,
  prevArrow: '.back1',
  nextArrow: '.next1',
  draggable: false,
  responsive: [
    {
      breakpoint: 2000,
      settings: {
        dots: false,
      }
    },
    {
      breakpoint: 455,
      settings: {
        arrows: false,
        dots: true,
      }
    },
    
  ]
});

$('#experiences').slick({
  dots: true,
  arrows: false,
  slidesToShow: 2,
  responsive: [
    {
      breakpoint: 460,
      settings: {
        slidesToShow: 1
      }
    },
    
  ]
});

$('#sliderHabitat').slick({
  dots: true,
  arrows: false,
  slidesToShow: 1,
});

$('#experiences2').slick({
  arrows: false,
  dots: true,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 460,
      settings: {
        slidesToShow: 1
      }
    },
    
  ]
});

$('#testimonial').slick({
  dots: false,
  arrows: true,
  slidesToShow: 2,
  prevArrow: '.back2',
  nextArrow: '.next2',
  draggable: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        dots: true,
        //draggable: true
      }
    },
  ]
});

$('#activities1').slick({
  arrows: true,
  dots: false,
  prevArrow: '.back4',
  nextArrow: '.next4',
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1100,
      settings: {
        dots: true,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 800,
      settings: {
        dots: true,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 460,
      settings: {
        dots: true,
        slidesToShow: 1
      }
    },
  ]
});

$('#attractions').slick({
  dots: true,
  arrows: false,
  slidesToShow: 1,
});

$('#holidays').slick({
  dots: false,
  arrows: false,
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    },
  ]
});